<template>
  <div class="root">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style>
  .root {
    width: 100%;
    height: 100%;
  }
</style>
